import {type Element} from 'slate';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import {isWeave1Panel} from './plugins/weave-panels';

export function getDeepLinkId(element: Element): string | undefined {
  if (element.type === 'heading') {
    return element.children
      .map(c => c.text)
      .join('')
      .replace(/\s+/g, '-')
      .toLowerCase();
  }
  if (isWeave1Panel(element)) {
    return element.config.panelConfig.config.documentId;
  }
  return undefined;
}

export function getDeepLinkIdFromText(text: string): string {
  return text.replace(/\s+/g, '-').toLowerCase();
}
